import React from 'react';
import { Link } from 'react-router-dom';

// The season's key facts (dates, fees, venue), read from src/shared/seasons.js
// so the FAQ, Rules and Home can never disagree with checkout.

export const formatDay = (iso) => new Date(iso).toLocaleDateString('en-CA', {
  year: 'numeric', month: 'long', day: 'numeric', timeZone: 'America/Toronto',
});

/** "January 31, 2027" style date of the season's event, or its placeholder text. */
export const eventWhen = (season) => (season.eventDate ? formatDay(season.eventDate) : season.eventWhen || 'To be announced');
export const venueText = (season) => season.venue || season.venueNote || 'To be announced';

/** [label, value] rows for "2027 at a glance". */
export function seasonFacts(season) {
  const p = season.prices;
  const rows = [
    new Date() >= new Date(season.opensAt)
      ? ['Registration', 'Open now']
      : ['Registration opens', formatDay(season.opensAt)],
    ['Registration closes', season.closesAt ? formatDay(season.closesAt) : 'To be announced (about 2 weeks before competition day)'],
    ['Competition day', eventWhen(season)],
    ['Venue', venueText(season)],
  ];
  if (p) {
    rows.push(
      ['Registration fee', season.earlyBirdEndsAt
        ? `$${p.registration}, or $${p.registrationEarlyBird} if you pay by ${formatDay(season.earlyBirdEndsAt)}`
        : `$${p.registration}`],
      ['Solo', `$${p.solo} each (up to 2)`],
      ['Ensemble', `$${p.ensemble} per dancer (up to 2)`],
    );
    if (season.comboEndsAt) {
      rows.push(['Solo + ensemble deal', `$${p.combo} instead of $${p.solo + p.ensemble}, until ${formatDay(season.comboEndsAt)}`]);
    }
  }
  rows.push(
    ['Performance video', 'Free for every dancer'],
    ['Photos', 'Buy them on competition day. Details are shared 1 month before.'],
  );
  return rows;
}

export const SeasonAtAGlance = ({ season, id }) => (
  <div id={id} className="card" style={{
    borderTop: '4px solid var(--primary-gold)', padding: 'clamp(1.25rem, 4vw, 2rem)',
    textAlign: 'left', maxWidth: '760px', margin: '0 auto',
  }}>
    <h2 style={{ textAlign: 'left', marginTop: 0, marginBottom: '1rem', fontSize: '1.5rem' }}>
      {season.year} at a glance
    </h2>
    <dl style={{ margin: 0 }}>
      {seasonFacts(season).map(([label, value]) => (
        <div key={label} style={{
          display: 'flex', flexWrap: 'wrap', gap: '0.15rem 1rem',
          padding: '0.6rem 0', borderBottom: '1px solid #eee',
        }}>
          <dt style={{ flex: '0 0 11rem', fontWeight: 600, color: 'var(--charcoal)' }}>{label}</dt>
          <dd style={{ flex: '1 1 14rem', margin: 0, color: '#555' }}>{value}</dd>
        </div>
      ))}
    </dl>
    {season.prices && (
      <p style={{ margin: '0.9rem 0 0', fontSize: '0.9rem', color: 'var(--soft-gray)' }}>
        All prices are in Canadian dollars, plus 13% HST.
      </p>
    )}
  </div>
);

/** Row of section buttons at the top of a long page. Wraps on phones. */
export const JumpLinks = ({ items }) => (
  <nav aria-label="On this page" style={{
    display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.5rem',
    maxWidth: '860px', margin: '2rem auto', padding: '0 16px',
  }}>
    {items.map(([id, label]) => (
      <a key={id} href={`#${id}`} style={{
        padding: '0.45rem 0.9rem', borderRadius: '999px', border: '1px solid var(--primary-gold)',
        color: 'var(--deep-gold)', textDecoration: 'none', fontWeight: 600, fontSize: '0.92rem',
        background: 'white',
      }}>
        {label}
      </a>
    ))}
  </nav>
);

export const InlineLink = ({ to, children }) => (
  <Link to={to} style={{ color: 'var(--deep-gold)', fontWeight: 600 }}>{children}</Link>
);
